/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityContactResult
 */
export interface ControlEntityContactResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    contact_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityContactResult
     */
    immutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    contact_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    cadency?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityContactResult
     */
    search?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityContactResult
     */
    disabled?: boolean;
}

/**
 * Check if a given object implements the ControlEntityContactResult interface.
 */
export function instanceOfControlEntityContactResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityContactResultFromJSON(json: any): ControlEntityContactResult {
    return ControlEntityContactResultFromJSONTyped(json, false);
}

export function ControlEntityContactResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityContactResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'contact_id': !exists(json, 'contact_id') ? undefined : json['contact_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'immutable': !exists(json, 'immutable') ? undefined : json['immutable'],
        'contact_type': !exists(json, 'contact_type') ? undefined : json['contact_type'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'cadency': !exists(json, 'cadency') ? undefined : json['cadency'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function ControlEntityContactResultToJSON(value?: ControlEntityContactResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external_id': value.external_id,
        'contact_id': value.contact_id,
        'name': value.name,
        'email': value.email,
        'immutable': value.immutable,
        'contact_type': value.contact_type,
        'created': value.created,
        'updated': value.updated,
        'cadency': value.cadency,
        'search': value.search,
        'disabled': value.disabled,
    };
}

